export default __webpack_public_path__ + "static/media/Oceania.5d244812.svg";